import React, { useState } from "react";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import { CButton, CCardLink, CContainer, CCol, CRow } from "@coreui/react-pro";
import { toast } from "react-toastify";
import AWS from 'aws-sdk'; 

const styles = { 
    sendButton: {
        width: "100px",
        fontSize: "18px",
        whiteSpace: "nowrap",
        borderRadius: "4px",
        backgroundColor: '#DC6FB4', 
        color: "white",
        marginTop: "3%",
        fontWeight: "bold",
        transition: 'all 0.5s ease', 
    },
};

const Contact = () => {

    const [isHovered, setIsHovered] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault(); 

        const name = event.target.elements.name.value;
        const email = event.target.elements.email.value;
        const message = event.target.elements.message.value;

        const ses = new AWS.SES({ region: "ap-southeast-2" });
        const userParams = {
            Source: 'webmaster@showeraway.com', 
            Destination: {
                ToAddresses: ['1647436136@qq.com'], 
            },
            Message: {
                Subject: { Data: "Message from Contact Form" },
                Body: { Text: { Data: `Name: ${name}\nEmail: ${email}\nMessage: ${message}` } }
            },
        };

        try {
            await ses.sendEmail(userParams).promise();
            toast.success("Message sent successfully");
        } catch (error) {
            console.error("Error sending message:", error);
            toast.error("Failed to send message");
        }
    };

    return (
        <div className="d-flex flex-row align-items-center justify-content-center" style={{ height: 'auto', minHeight:'100vh'}}>
            <div className="d-flex flex-wrap" style={{padding: '5%'}}>
            <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-start mb-5">
                <h1 className=" mb-5" >Contact Us</h1>
                <div className="text-gray row justify-content-center" style={{ width: '350px' }}>
                    <CRow className="justify-content-center">
                        <CCol xs={2} className="text-light"><LocationOnIcon className="fs-2"/></CCol>
                        <CCol xs={8}><p>Shower Away Pty Ltd <br />Suite 1088, 30 Denison St <br />Bondi NSW 2022 <br />ABN: 60 661 931 684</p></CCol>
                    </CRow>
                    <CRow className="justify-content-center">
                        <CCol xs={2} className="text-light"><LocalPhoneIcon className="fs-2"/></CCol>
                        <CCol xs={8}><p>0430 525 188 (Peter)</p></CCol>
                    </CRow>
                    <CRow className="justify-content-center">
                        <CCol xs={2} className="text-light"><EmailIcon className="fs-2"/></CCol>
                        <CCol xs={8}><CCardLink href="mailto: hello@showeraway.com" className="text-gray">hello@showeraway.com</CCardLink></CCol>
                    </CRow>
                </div>
            </div>
            <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-start mb-5">
                <h2 className=" mb-4">Send a Message</h2>
                <div className="text-gray row justify-content-center" style={{ width: '350px' }}>
                    <CRow className="justify-content-start">
                        <CCol xs={12}>
                            <form onSubmit={handleSubmit}> 
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input type="text" id="name" className="form-control" placeholder="Enter your name" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">E-mail</label>
                                    <input type="email" id="email" className="form-control" placeholder="Enter your email" required />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label">Message</label>
                                    <textarea id="message" className="form-control" placeholder="Enter your message"></textarea>
                                </div>
                                <CButton
                                    type="submit"
                                    size="lg"
                                    style={{
                                        ...styles.sendButton,
                                        backgroundColor: isHovered ? '#ebaed5' : '#DC6FB4', 
                                    }}
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                >
                                    Submit
                                </CButton>
                            </form>
                        </CCol>
                    </CRow>                        
                </div>
            </div>
            </div>
        </div>
    );
}

export default Contact;
